import { cn } from '@telesoft/lib/web/cn'
import * as React from 'react'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex py-2 pl-0 pr-4 md:pr-5 w-full appearance-none relative text-sm lg:text-base duration-150 ease-in-out border-b border-b-black placeholder-body min-h-12 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none  disabled:cursor-not-allowed disabled:opacity-50',
          'bg-transparent focus:outline-none focus:border-telesoft h-11 md:h-12 text-input',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
